/**
 * @desc 根据id查询
 */
import { DictEntity } from '@eastcoal/api/system/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryDictParameter = {
  id?: string
}

const method = 'GET'
const url = '/system/dict'

export const queryDictApi = (
  params?: QueryDictParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<DictEntity>({
    method,
    url,
    params,
    ...config
  })
}

queryDictApi.method = method
queryDictApi.url = url
